// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","overlayContainer":"_1xOYA","inline":"X-vQN","title":"_3f4TE","description":"N181v","button":"_2GvNX","modal":"okBNH"};